import { Store, AnyAction } from 'redux';
import { RootState } from './types';

/**
 * Store container class used for getting access to an instance of the store
 */
export class ReduxStoreContainer {
  store?: Store<RootState, AnyAction>;

  storeIsSet() {
    return !!this.store;
  }

  setStore(store: Store<RootState, AnyAction>) {
    this.store = store;
  }

  getState() {
    if (!this.store) {
      throw new Error('Store has not been set');
    }

    return this.store.getState();
  }

  dispatch(action: AnyAction) {
    if (!this.store) {
      throw new Error('Store has not been set');
    }

    return this.store.dispatch(action);
  }
}

export default new ReduxStoreContainer();
